export function PreviewBadge() {
  return (
    <span className="ml-2 inline-flex items-center rounded border border-gray-300 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-gray-500">
      PREVIEW
    </span>
  )
}
